import { createContext, useContext } from 'react'

type ContextType = {
  certSlug: string
}

const CertificateSlugContext = createContext<ContextType | null>(null)

export const CertificateSlugProvider = ({
  children,
  value,
}: {
  children: React.ReactNode
  value: ContextType
}) => (
  <CertificateSlugContext.Provider value={value}>
    {children}
  </CertificateSlugContext.Provider>
)

export const useCertificateSlug = () => {
  const context = useContext(CertificateSlugContext)
  if (!context) {
    throw new Error(
      'useCertificateSlug must be used within a CertificateSlugProvider',
    )
  }
  return context
}
